import { supabase } from '../../lib/supabaseClient';

export const CATEGORIES = [
  'All',
  'Men',
  'Women',
  'Kids',
  'Lifestyle',
  'Running',
  'Sandals & Slides',
  'Caps',
  'Football cleats',
  'Football shirts',
  'Clothing',
  'Bags',
];
export const BRANDS     = ['All Brands', 'Nike', 'Adidas', 'Puma', 'New Balance', 'Converse', 'LaCoste', 'Jordan', 'Diesel', 'On Cloud', 'Alexander McQueen', 'Karl Lagerfeld', 'Hugo Boss', 'TimberLand', 'Birkenstock', 'Dior', 'Hoka', 'New era', 'alo'];

export async function fetchProducts() {
  const { data, error } = await supabase
    .from('products')
    .select('*')
    .order('created_at', { ascending: false });
  if (error) throw error;
  return data.map(normalise);
}

export async function fetchFeaturedProducts() {
  // Get slot assignments
  const { data: slotData, error: slotError } = await supabase
    .from('featured_slots')
    .select('*')
    .limit(1)
    .single();

  if (slotError || !slotData) return [];

  // Collect non-empty slot IDs in slot order
  const ids = [
    slotData.slot_1,
    slotData.slot_2,
    slotData.slot_3,
    slotData.slot_4,
    slotData.slot_5,
  ].filter(Boolean);

  if (ids.length === 0) return [];

  // Fetch those products
  const { data, error } = await supabase
    .from('products')
    .select('*')
    .in('id', ids);

  if (error) throw error;

  // Return in exact slot order, filter out any nulls
  return ids
    .map(id => {
      const p = data.find(p => String(p.id) === String(id));
      return p ? normalise(p) : null;
    })
    .filter(Boolean);
}

function normalise(p) {
  return {
    id:            p.id,
    name:          p.name,
    brand:         p.brand,
    category:      p.category,
    price:         p.price,
    originalPrice: p.original_price,
    tag:           p.tag,
    colorway:      p.colorway,
    description:   p.description,
    sizes:         p.sizes   || [],
    images:        p.images  || [],
    details:       p.details || [],
    inStock:       p.in_stock,
  };
}